/**
 * Production services menu and content for Panthi Event Management
 */

export const productionIntro = {
  title: 'Production',
  tagline: 'Complete event production solutions — from creative design to on-ground execution.',
  bannerImageAlt:
    'Event production — stage, lighting, and LED setup by Panthi Events in Ahmedabad, Gujarat, India',
  description: `At Panthi Event Management, we provide complete event production solutions to deliver high-quality, visually impressive, and professionally managed events. We handle everything from creative design, stage setup, lighting, sound, LED walls, décor, catering coordination, and technical production to artist coordination, security, licensing, logistics, and on-ground event support.
With experienced teams, modern equipment, and trusted technical partners, we ensure smooth execution, premium quality setups, and timely delivery. Our focus is to create well-organized, impactful, and memorable events for every client.

Production house events India clients trust Panthi Events for projects that span weddings, corporate showcases, concerts, and public programmes across Ahmedabad, Gujarat, and nationwide. We align creative direction with technical reality—truss loads, power distribution, audio tuning, and LED content—so your show looks premium and runs safely. Whether you need a compact corporate stage or a festival-scale rig, our planners coordinate vendors, permits, and rehearsal windows with clear documentation.

As a concert organizer Gujarat teams partner with for sound, lights, and crowd plans, we think end-to-end: artist green rooms, show calling, VIP entries, and contingency power. Corporate event organizer India programmes benefit from branded backdrops, delegate registration flows, and hybrid streaming options without sacrificing polish. From English runbooks to Hindi and Gujarati coordination on site, we keep hosts, families, and crews aligned under one event management company in Gujarat mindset: calm execution, memorable output.`,
};

export const productionServices = [
  {
    id: 'decoration',
    title: 'Decoration',
    description: 'We provide creative and theme-based decoration solutions that match the concept and purpose of the event. Our team focuses on color combinations, material quality, and design finishing to create attractive and elegant event environments.',
  },
  {
    id: 'stage-setup',
    title: 'Stage & Setup',
    description: 'We design and execute professional stage setups with proper layout planning, backdrop design, and structural safety. Our stage setups are suitable for corporate events, weddings, concerts, and large public gatherings.',
  },
  {
    id: 'flower-decor',
    title: 'Flower Decor',
    description: 'We offer fresh flower and artificial flower decoration services including stage décor, entrance décor, and table arrangements. Our floral designs add natural beauty and luxury feel to the event.',
  },
  {
    id: 'light-decor',
    title: 'Light Decor',
    description: 'We provide decorative and technical lighting solutions such as ambient lighting, stage lighting, focus lighting, and theme lighting to enhance event mood and visual impact.',
  },
  {
    id: 'sound-audio',
    title: 'Sound & Audio',
    description: 'We provide high-quality professional sound systems with clear audio output. Our audio solutions are suitable for speeches, live performances, concerts, and large audience events.',
  },
  {
    id: 'led-visual',
    title: 'LED & Visual',
    description: 'We provide LED walls, projection systems, and visual display solutions for live visuals, presentations, branding, and entertainment. Our visual setups improve audience experience.',
  },
  {
    id: 'catering',
    title: 'Catering',
    description: 'We coordinate with professional catering partners to provide quality food service, menu planning support, and smooth food service management for guests.',
  },
  {
    id: 'camera-live-streaming',
    title: 'Camera & Live Streaming',
    description: 'We provide professional photography, videography, and multi-camera live streaming solutions for online and offline audience coverage.',
  },
  {
    id: 'dj-entertainment',
    title: 'DJ & Entertainment',
    description: 'We provide DJ setup, live entertainment coordination, and performance management to create energetic and engaging event experiences.',
  },
  {
    id: 'truss-structure',
    title: 'Truss & Structure',
    description: 'We provide strong and safe truss structures for lighting, LED walls, branding, and stage support with proper safety standards and technical installation.',
  },
  {
    id: 'furniture-decor',
    title: 'Furniture & Decor',
    description: 'We provide premium event furniture including sofas, chairs, tables, lounge setups, and theme-based decorative elements to enhance guest comfort and event look.',
  },
  {
    id: 'branding-print',
    title: 'Branding And Print',
    description: 'We provide complete event branding solutions including flex printing, standees, backdrops, signage boards, and promotional printing materials.',
  },
  {
    id: 'special-effects',
    title: 'Special Effects',
    description: 'We provide advanced special effects solutions to create high-impact event experiences. Our services include smoke effects, cold pyros, confetti blasts, CO2 effects, sparkular machines, and laser shows to enhance stage performances and audience engagement.',
  },
  {
    id: 'manpower-management',
    title: 'Manpower & Management',
    description: 'We provide trained and professional event manpower including event coordinators, technical staff, setup teams, and support staff. Our management team ensures smooth event flow, proper coordination, and on-time execution.',
  },
  {
    id: 'logistics-support',
    title: 'Logistics & Support',
    description: 'We manage complete event logistics including material transport, equipment handling, vendor coordination, and on-ground technical support to ensure smooth event operations from setup to completion.',
  },
  {
    id: 'food-hospitality',
    title: 'Food & Hospitality',
    description: 'We provide guest hospitality management including welcome arrangements, guest handling, service coordination, and food service supervision to ensure premium guest experience.',
  },
  {
    id: 'virtual-hybrid-event',
    title: 'Virtual/Hybrid Event',
    description: 'We provide complete virtual and hybrid event production solutions including live streaming setup, virtual platform management, online audience engagement tools, and technical support for digital event execution.',
  },
  {
    id: 'venue-booking',
    title: 'Venue Booking',
    description: 'We provide complete venue booking assistance based on your event type, audience size, and budget. From banquet halls and hotels to outdoor venues and convention centers, we help you select and secure the perfect location for your event.',
  },
  {
    id: 'photobooth',
    title: 'Photobooth',
    description: 'We provide creative and customized photobooth setups with instant photo printing, digital sharing options, themed backdrops, and fun props to enhance guest engagement and create memorable experiences.',
  },
  {
    id: 'artist-celebrity-management',
    title: 'Artist & Celebrity Management',
    description: 'We provide artist and celebrity booking services including singer, DJ, performers, anchors, and celebrity guest coordination. Our team manages artist contracts, technical requirements, travel, and hospitality arrangements.',
  },
  {
    id: 'security-management',
    title: 'Security Management',
    description: 'We provide professional event security services including entry control, crowd management, VIP security, and on-ground safety coordination to ensure safe and well-managed events.',
  },
  {
    id: 'ticketing-registration',
    title: 'Ticketing & Registration System',
    description: 'We provide complete ticketing and registration solutions including online ticket sales, QR-based entry management, on-site registration counters, and attendee data management for smooth event entry flow.',
  },
  {
    id: 'event-licensing',
    title: 'Event Licensing & Permissions Support',
    description: 'We provide complete support for event licensing and government permissions required for smooth event execution. Our team assists with local authority approvals, police permissions, music licenses, and venue compliance documentation.',
  },
  {
    id: 'fire-safety',
    title: 'Fire & Safety Arrangement',
    description: 'We ensure complete fire and safety arrangements including fire extinguishers, emergency exit planning, safety signage, and coordination with local safety authorities to maintain a secure event environment.',
  },
  {
    id: 'power-backup',
    title: 'Power Backup',
    description: 'We provide reliable power backup solutions including generators, power distribution planning, and technical monitoring to ensure uninterrupted event operations without power failure issues.',
  },
  {
    id: 'backstage-management',
    title: 'Backstage Management',
    description: 'Our backstage management team handles artist coordination, entry and exit flow, technical cue management, green room arrangements, and backstage security to ensure smooth show operations.',
  },
  {
    id: 'creative-designing',
    title: 'Creative Designing',
    description: 'We provide professional creative designing services including stage design concepts, theme designing, branding creatives, digital artwork, and event visual presentation planning.',
  },
  {
    id: 'technical-support',
    title: 'On-Ground Technical Support Team',
    description: 'Our experienced technical support team manages live event operations including sound, light, LED, special effects, and technical troubleshooting to ensure flawless event execution.',
  },
];
